import { hyphenate } from "./string"

const msPattern = /^ms-/;

export const hyphenateStyleName = (str: string) => hyphenate(str).replace(msPattern, '-ms-');